import { ITheme } from "../../utils/theme";

export const inputStyle = (theme: ITheme) => ({
  minHeight: '5rem',
  background: 'white',
  '& .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline, & .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline, .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.info.light,
    borderWidth: '3px'
  },
  '& .MuiInputBase-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.red[700],
  }
});

export const messageStyle = (theme: ITheme) => ({
  margin: '60px 40px',
  color: theme.palette.corporateBlue
});